module.exports = __webpack_public_path__ + "home/img/GAMEHOST-L(白字).b8710069.webp";